import "rc-slider/assets/index.css";
import RcSlider, { SliderProps } from "rc-slider/lib/Slider";
import { palette } from "@ottatech/design";

export function Slider(
  props: Omit<
    SliderProps,
    "handleStyle" | "labelStyle" | "trackStyle" | "railStyle"
  >
): React.ReactElement {
  return (
    <RcSlider
      handleStyle={{
        borderColor: palette.brand.yellow,
        borderWidth: "4px",
        color: palette.brand.yellow,
        width: "18px",
        height: "18px",
        marginTop: "-7px",
      }}
      trackStyle={{
        backgroundColor: palette.brand.grey,
      }}
      railStyle={{
        backgroundColor: palette.brand.grey,
      }}
      {...props}
    />
  );
}
